// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ManOutlinedSvg from "@ant-design/icons-svg/es/asn/ManOutlined";
import AntdIcon from '../components/AntdIcon';

var ManOutlined = function ManOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ManOutlinedSvg
  }));
};

ManOutlined.displayName = 'ManOutlined';
export default React.forwardRef(ManOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ManOutlined.js
// module id = 1451
// module chunks = 0